import SubscribeToGotham from './SubscribeToGotham';

export default SubscribeToGotham;
